module.exports = __webpack_public_path__ + "static/media/expansores.7c523047.png";